import { Pipe, PipeTransform } from '@angular/core';

import { IAdditionalComponentsCatalogueCart } from '../../enclosure/models/product-accessories.model';

@Pipe({
    name: 'numberOfAdditionalComponentsInCart',
    standalone: false
})
export class NumberOfAdditionalComponentsInCartPipe implements PipeTransform {

  transform(addedProducts: IAdditionalComponentsCatalogueCart[]): number {
    return addedProducts?.reduce((total, item) => total + item.quantity, 0);
  }

}
